import { z } from "zod";
import { paginationSchema } from "./common.js";

export const auditLogListQuerySchema = paginationSchema.extend({
  actorId: z.string().uuid().optional(),
  action: z.string().optional(),
  actionPrefix: z.string().optional(),
  siteId: z.string().uuid().optional(),
  payPeriodId: z.string().uuid().optional(),
  dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  q: z.string().optional(),
});

export const auditLogEntrySchema = z.object({
  id: z.string().uuid(),
  companyId: z.string().uuid(),
  actorId: z.string().uuid().nullable(),
  actorName: z.string().nullable(),
  actorEmail: z.string().nullable(),
  action: z.string(),
  actionLabel: z.string(),
  targetType: z.string(),
  targetId: z.string().uuid().nullable(),
  targetLabel: z.string().nullable(),
  siteId: z.string().uuid().nullable(),
  siteCode: z.string().nullable(),
  siteName: z.string().nullable(),
  payPeriodId: z.string().uuid().nullable(),
  payPeriodLabel: z.string().nullable(),
  before: z.record(z.unknown()).nullable(),
  after: z.record(z.unknown()).nullable(),
  reason: z.string().nullable(),
  createdAt: z.string(),
  hasDiff: z.boolean(),
});

export const auditLogFilterOptionsSchema = z.object({
  actors: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string().nullable(),
      email: z.string().nullable(),
    }),
  ),
  actions: z.array(z.object({ value: z.string(), label: z.string() })),
  sites: z.array(
    z.object({
      id: z.string().uuid(),
      code: z.string(),
      name: z.string(),
    }),
  ),
  payPeriods: z.array(
    z.object({
      id: z.string().uuid(),
      label: z.string(),
    }),
  ),
});

export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;
export type AuditLogFilterOptions = z.infer<typeof auditLogFilterOptionsSchema>;
